import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Pricing } from '../components/Pricing';
import { Websites } from '../components/Websites';
import { ClosingCTA } from '../components/ClosingCTA';
import { SEOHead } from '../components/SEOHead';
const faq = [{
  question: 'How much does the Viridia Analytics system cost?',
  answer: 'The Complete System is $1,197 per month and includes the CRM, AI receptionist, marketing, reputation management, support, and monthly ad reporting.'
}, {
  question: 'Is there a contract?',
  answer: 'No. Everything is month to month. We believe in earning it.'
}, {
  question: 'What costs extra?',
  answer: 'Ad management is added to your plan with a custom quote based on your budget and platforms. A website build is a separate one-time cost plus $30 per month hosting.'
}];
export function PricingPage() {
  return <>
      <SEOHead title="Pricing | One All-in-One System, Month to Month | Viridia Analytics Phoenix" description="One complete system at $1,197/month. CRM, AI receptionist, marketing, reputation, and support. Month to month. Ads and websites optional." canonical="/pricing" faq={faq} data-id="element-2671" data-mp="1lbzlahyn29r6" />

      <PageHeader label="Pricing" title="What it costs." intro="One system, one price. Ads and a website build are the only add-ons." data-id="element-2672" data-mp="1sr3gk7yfas03" />

      <Pricing data-id="element-2673" data-mp="21pfg4zh9p04o" />
      <Websites data-id="element-2674" data-mp="21p5shijp3525" />
      <ClosingCTA data-id="element-2675" data-mp="21om8zxeec8m0" />
    </>;
}